import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "../generalSuccessPopup/generalSuccessPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";
import { Link } from "react-router-dom";

function InactivityLogoutPopup({ onClose }: IPopupWithoutProps) {
  return (
    <article className={popupStyles.popup}>
      <img
        src={doctor}
        alt={t("IMAGE_ALT_VENCHY_DOCTOR")}
        className={popupStyles.popup__img}
      />
      <p className={`${popupStyles.popup__title} ${popupStyles.popup__title_small}`}>
        {t("INACTIVITY_LOGOUT_TITLE")}
      </p>
      <p className={popupStyles.popup__text}>
        {t("INACTIVITY_LOGOUT_TEXT")}
      </p>
      <Link
        to={"/"}
        className={`button hover ${popupStyles.popup__nextBtn}`}
        onClick={onClose}
      >
        {t("INACTIVITY_LOGOUT_BUTTON")}
      </Link>
    </article>
  );
}

export default InactivityLogoutPopup;
